export default "__VITE_ASSET__BNAc$E46__"